import { render, staticRenderFns } from "./dingxiangselect_detail.vue?vue&type=template&id=1b88f152&scoped=true"
import script from "./dingxiangselect_detail.vue?vue&type=script&lang=js"
export * from "./dingxiangselect_detail.vue?vue&type=script&lang=js"
import style0 from "./dingxiangselect_detail.vue?vue&type=style&index=0&id=1b88f152&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b88f152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b88f152')) {
      api.createRecord('1b88f152', component.options)
    } else {
      api.reload('1b88f152', component.options)
    }
    module.hot.accept("./dingxiangselect_detail.vue?vue&type=template&id=1b88f152&scoped=true", function () {
      api.rerender('1b88f152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/doubleRandom/projectExtract/dingxiangselect_detail.vue"
export default component.exports